import { firmHomeUrl } from 'common/config/urls';
import { Avatar, ListItem, ListItemIcon, ListItemText } from 'components/ui';
import SelectionPinButton from 'pages/Auth/components/SelectionPinButton';
import { getInitials } from 'utilities';
import { FirmOptionProps } from './FirmOption.props';
import { firmOptionClasses, StyledLink } from './FirmOption.styles';
import { getFirmOptionTestId } from './FirmOption.testIds';

const FirmOption = ({
  slug,
  name,
  id,
  isPinnable = false,
  isPinned = false,
  updatePinStatus,
  iconUrl,
}: FirmOptionProps) => (
  <ListItem
    secondaryAction={
      isPinnable ? (
        <SelectionPinButton id={id} isPinned={isPinned} onToggle={updatePinStatus} title={name} />
      ) : undefined
    }
  >
    <StyledLink to={firmHomeUrl(slug)} data-testid={getFirmOptionTestId(slug)}>
      <ListItemIcon>
        {iconUrl ? (
          <Avatar className={`${firmOptionClasses.avatar} ${firmOptionClasses.avatarWithIcon}`} src={iconUrl} />
        ) : (
          <Avatar className={firmOptionClasses.avatar}>{getInitials({ name })}</Avatar>
        )}
      </ListItemIcon>
      <ListItemText primary={name} />
    </StyledLink>
  </ListItem>
);

export default FirmOption;
